import { render, staticRenderFns } from "./BaseCardList.vue?vue&type=template&id=781f975e&scoped=true&"
import script from "./BaseCardList.vue?vue&type=script&lang=js&"
export * from "./BaseCardList.vue?vue&type=script&lang=js&"
import style0 from "./BaseCardList.vue?vue&type=style&index=0&id=781f975e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "781f975e",
  null
  
)

export default component.exports